import { isMobileDevice } from '@repo-level/core-front/helpers/common';
import androidAppSrc from 'assets/images/mobileApp/downloadAndroid.webp';
import iosWebAppSrc from 'assets/images/mobileApp/downloadIOS.webp';
import { isIos } from 'helpers/common';
import type { MobileAppApi } from 'modules/mobileApp/api';
import { MOBILE_APP_PAGE_URL } from 'modules/mobileApp/helpers';

export interface DownloadButtonConfig {
  src: string;
  alt: string;
  getHref: (data: MobileAppApi, download?: boolean) => string;
  shouldShow: (data?: MobileAppApi) => boolean;
}

export const downloadButtonConfig: Record<string, DownloadButtonConfig> = {
  android: {
    src: androidAppSrc,
    alt: 'Google Play link',
    getHref: (data, download) =>
      download && data.androidApk ? data.androidApk.url : MOBILE_APP_PAGE_URL,
    shouldShow: (data) => !(isIos() && isMobileDevice) && !!data?.androidApk,
  },
  ios: {
    src: iosWebAppSrc,
    alt: 'App Store link',
    getHref: () => MOBILE_APP_PAGE_URL,
    shouldShow: () => isIos() || !isMobileDevice,
  },
};

export const getActiveConfigs = (
  data: MobileAppApi
): DownloadButtonConfig[] => {
  const { ios, android } = downloadButtonConfig;
  const configs: DownloadButtonConfig[] = [];

  if (ios.shouldShow()) configs.push(ios);
  if (android.shouldShow(data)) configs.push(android);

  return configs;
};
